import React, { useContext, useEffect } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";

// Helpers
import createPermsObj from "../../utils/permissionsHelper";

// Context
import { AuthContext } from "../../context/AuthContext";
import { ChatContext } from "../../context/chat/ChatContext";

// Utils
import { changeLayoutColor } from "../../redux/actions";
import * as layoutConstants from "../../data/layout";

// Components
import ChatUsers from "./ChatUsers";
import ChatArea from "./ChatArea";

/**
 * Componente funcional que renderiza la sección de Chats
 *
 * @returns {JSX.Element} Componente de react
 */
const Chat = () => {
  // Contexto del chat
  const { chatState } = useContext(ChatContext);
  const { activeChat } = chatState;

  // Información del usuario autenticado
  const { auth } = useContext(AuthContext);
  const { permissions } = auth;

  // Dispatch para ejecutar acciones de Redux
  const dispatch = useDispatch();

  // Permisos de la sección de Chats
  const chatPerms = createPermsObj(permissions, "Gestión de Chats");

  useEffect(() => {
    // Leer la preferencia del esquema de color del usuario de localStorage
    const savedColorScheme = localStorage.getItem("layoutColorScheme");

    // Si hay una preferencia guardada, actualizar el estado del layout con esa preferencia
    if (savedColorScheme) {
      dispatch(
        changeLayoutColor(
          savedColorScheme === "dark"
            ? layoutConstants.LAYOUT_COLOR_DARK
            : layoutConstants.LAYOUT_COLOR_LIGHT
        )
      );
    }
  }, []);

  return (
    <Row className="">
      {chatPerms.access && (
        <Col xl={3} md={6} className="px-1">
          <ChatUsers />
        </Col>
      )}

      {chatPerms.access && (
        <Col xl={9} md={6} className="px-1">
          {activeChat ? (
            <ChatArea />
          ) : (
            <Card
              className="d-none d-md-block"
              style={{
                height: "calc(100vh - 120px)",
              }}
            >
              <Card.Body className="d-flex flex-column justify-content-center align-items-center h-100">
                <h4 className="text-muted">
                  Selecciona un chat para comenzar una conversación
                </h4>
                <i className="mdi mdi-select-group text-muted h1" />
              </Card.Body>
            </Card>
          )}
        </Col>
      )}

      <ToastContainer />
    </Row>
  );
};

export default Chat;
